<template>
  <span v-if="isTop" class="tag is-warning is-light is-small top-firm-badge" data-test="top-firm-badge">פירמה מובילה</span>
</template>

<script>
// VA2 - small "פירמה מובילה" badge; renders nothing unless company.is_top_firm.
// Accepts the company as `company`, or as `payload` when used as a
// LinkEntity additional component.
export default {
  name: 'TopFirmBadge',
  props: {
    company: { type: Object, default: null },
    payload: { type: Object, default: null }
  },
  computed: {
    isTop () {
      const c = this.company || this.payload
      return !!c && (c.is_top_firm === true || c.is_top_firm === 1 || c.is_top_firm === 'true')
    }
  }
}
</script>

<style scoped>
.top-firm-badge { vertical-align: middle; }
</style>
